import { AllocationRepartition, MainAccountOverview, MasterHistory } from '@/types/main-account';
import { AxiosResponse } from 'axios';
import axiosInstance from '@/core/services/axiosInstance';
import { DataLineChart, ParamsChart } from '@/types/common';
import { TransactionFilterParams } from '@/types/filters';
import { cleanFilterParams } from '@/core/utils/filters';

export class MasterAccountService {
  private static readonly GET_MAIN_ACCOUNT_OVERVIEW = 'app/main-account/overview';
  private static readonly GET_MAIN_ACCOUNT_ALLOCATIONS = 'app/main-account/allocation';
  private static readonly GET_MASTER_HISTORIES_ENDPOINT = 'app/main-account/transactions';
  private static readonly GET_MASTER_REPORT = 'app/main-account/report';

  public static async getMainAccountOverview(): Promise<MainAccountOverview> {
    const res: AxiosResponse<MainAccountOverview> = await axiosInstance.get(MasterAccountService.GET_MAIN_ACCOUNT_OVERVIEW);
    return res.data;
  }

  public static async getMainAccountAllocation(): Promise<AllocationRepartition[]> {
    const res: AxiosResponse<AllocationRepartition[]> = await axiosInstance.get(MasterAccountService.GET_MAIN_ACCOUNT_ALLOCATIONS);
    return res.data;
  }

  public static async getMasterReport(params: ParamsChart): Promise<DataLineChart> {
    const { period } = params;
    const res: AxiosResponse<DataLineChart> = await axiosInstance.get(MasterAccountService.GET_MASTER_REPORT, {
      params: {
        period
      }
    });

    return res.data;
  }

  static async getMasterHistory(param: { offset: number; limit: number; filters?: TransactionFilterParams }): Promise<MasterHistory> {
    const { limit = 10, offset = 0, filters } = param;
    const res: AxiosResponse<MasterHistory> = await axiosInstance.get(MasterAccountService.GET_MASTER_HISTORIES_ENDPOINT, {
      params: {
        limit,
        offset,
        ...cleanFilterParams(filters),
      }
    })

    return res.data;
  }
}
